import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from './SEO';
import Navigation from './Navigation';

function ManufacturerSelect() {
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const manufacturers = [
    { name: 'Audi', logo: 'audi.png', path: '/brand/audi' },
    { name: 'BMW', logo: 'bmw.png', path: '/brand/bmw' },
    { name: 'Ford', logo: 'ford.png', path: '/brand/ford' },
    { name: 'Honda', logo: 'honda.png', path: '/brand/honda' },
    { name: 'Hyundai', logo: 'hyundai.png', path: '/brand/hyundai' },
    { name: 'Jaguar', logo: 'jaguar.png', path: '/brand/jaguar' },
    { name: 'Kia', logo: 'kia.png', path: '/brand/kia' },
    { name: 'Lexus', logo: 'lexus.png', path: '/brand/lexus' },
    { name: 'Mazda', logo: 'mazda.png', path: '/brand/mazda' },
    { name: 'Mini', logo: 'mini.png', path: '/brand/mini' },
    { name: 'Mitsubishi', logo: 'mitsubishi.png', path: '/brand/mitsubishi' },
    { name: 'Nissan', logo: 'nissan.png', path: '/brand/nissan' },
    { name: 'Subaru', logo: 'subaru.png', path: '/brand/subaru' },
    { name: 'Suzuki', logo: 'suzuki.png', path: '/brand/suzuki' },
    { name: 'Toyota', logo: 'toyota.png', path: '/brand/toyota' },
    { name: 'Volkswagen', logo: 'volkswagen.png', path: '/brand/volkswagen' },
    { name: 'Volvo', logo: 'volvo.png', path: '/brand/volvo' },
    { name: 'Holden', logo: 'holden.png', path: '/brand/holden' },
    { name: 'Jeep', logo: 'jeep.png', path: '/brand/jeep' },
    { name: 'Infiniti', logo: 'infiniti.png', path: '/brand/infiniti' },
    { name: 'Genesis', logo: 'genesis.png', path: '/brand/genesis' },
    { name: 'Ferrari', logo: 'ferrari.png', path: '/brand/ferrari' },
    { name: 'Fiat', logo: 'fiat.png', path: '/brand/fiat' },
    { name: 'Maserati', logo: 'maserati.png', path: '/brand/maserati' },
    { name: 'Lotus', logo: 'lotus.png', path: '/brand/lotus' },
    { name: 'Abarth', logo: 'abarth.png', path: '/brand/abarth' },
    { name: 'Škoda', logo: 'skoda.png', path: '/brand/skoda' },
    { name: 'Chery', logo: 'chery.png', path: '/brand/chery' },
    { name: 'Chevrolet', logo: 'chevrolet.png', path: '/brand/chevrolet' },
    { name: 'Datsun', logo: 'datsun.png', path: '/brand/datsun' },
    { name: 'Eicher', logo: 'eicher.png', path: '/brand/eicher' },
    { name: 'GMC', logo: 'gmc.png', path: '/brand/gmc' },
    { name: 'Isuzu', logo: 'isuzu.png', path: '/brand/isuzu' },
    { name: 'JMC', logo: 'jmc.png', path: '/brand/jmc' },
    { name: 'Mahindra', logo: 'mahindra.png', path: '/brand/mahindra' },
    { name: 'Renault Samsung', logo: 'renault-samsung.png', path: '/brand/renault-samsung' },
    { name: 'Tata', logo: 'tata.png', path: '/brand/tata' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-black">
      <SEO
        title="Select Your Car Manufacturer - Carkey Solutions"
        description="Choose your car manufacturer for professional key replacement services. We support all major brands including Toyota, Honda, Ford, BMW, Audi and more."
        keywords="car manufacturer selection, car key replacement perth, automotive locksmith perth"
      />
      
      {/* Header */}
      <Navigation />

      {/* Main Content */}
      <div className="container-max px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Select Your <span className="text-carkey-red">Manufacturer</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Choose your car brand below and we'll provide you with specialized key replacement services tailored to your vehicle
          </p>
        </div>

        {/* Manufacturer Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 mb-8">
          {manufacturers.map((manufacturer) => (
            <button
              key={manufacturer.name}
              onClick={() => navigate(manufacturer.path)}
              className="group bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/20 hover:border-carkey-red/50 transition-all duration-300 transform hover:scale-105"
            >
              <div className="flex flex-col items-center space-y-4">
                <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center p-3 group-hover:shadow-lg transition-all duration-300">
                  <img 
                    src={`/tmp/${manufacturer.logo}`} 
                    alt={manufacturer.name} 
                    className="max-w-full max-h-full object-contain filter group-hover:brightness-110"
                  />
                </div>
                <div className="text-white font-semibold text-sm text-center group-hover:text-carkey-red transition-colors">
                  {manufacturer.name}
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Other Brand Option */}
        <div className="text-center mb-12">
          <div className="inline-block">
            <button
              onClick={() => navigate('/quote')}
              className="group bg-gradient-to-r from-carkey-red to-red-600 backdrop-blur-xl border border-carkey-red/30 rounded-2xl p-6 hover:shadow-2xl hover:shadow-carkey-red/25 hover:-translate-y-1 transition-all duration-500 transform hover:scale-105"
            >
              <div className="flex flex-col items-center space-y-4">
                <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center p-3 group-hover:shadow-lg transition-all duration-300">
                  <i className="fas fa-car text-white text-2xl group-hover:scale-110 transition-transform duration-300"></i>
                </div>
                <div className="text-white font-semibold text-sm text-center">
                  Other Brand
                </div>
                <div className="text-white/80 text-xs text-center">
                  Direct to Quote Form
                </div>
              </div>
            </button>
          </div>
        </div>

        {/* Contact Section */}
        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 text-center">
          <h2 className="text-2xl font-bold text-white mb-4">
            Can't see your car's manufacturer above?
          </h2>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Don't stress! We can still help. Carkey Solutions is Perth's leading Automotive Locksmith. 
            Feel free to give us a call or fill out our quote request form and one of our friendly 
            Automotive Locksmiths will contact you directly to discuss your options.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+61430168669"
              className="bg-gradient-to-r from-carkey-red to-red-600 text-white px-8 py-4 rounded-2xl font-semibold hover:shadow-2xl hover:shadow-carkey-red/25 hover:-translate-y-1 transition-all duration-500"
            >
              <i className="fas fa-phone mr-2"></i>
              Call Us Now
            </a>
            <button
              onClick={() => navigate('/quote')}
              className="bg-white/10 border border-white/20 text-white px-8 py-4 rounded-2xl font-semibold hover:bg-white/20 hover:border-carkey-red/50 transition-all duration-300"
            >
              <i className="fas fa-paper-plane mr-2"></i>
              Request Quote
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManufacturerSelect;
